
    export default function getServerDisplayName(server) {
        var serverDisplayName = server;
        if (server === 'Developer Imp Servers') {
            serverDisplayName = 'Development';
        } else if (server === 'Production Imp Servers') {
            serverDisplayName = 'Production';
        }
        return serverDisplayName;
    }
